import cn from 'classnames';
import { ReactNode } from 'react';

type TableCellTextProps = {
  children: ReactNode;
  uppercase?: boolean;
};

export const TableCellTextMR = ({ children, uppercase }: TableCellTextProps) => (
  <span className={cn('text-m-r', { uppercase })}>{children}</span>
);
